import { inject, observer } from "mobx-react";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const UploadSortBtn = inject("mainStore")(
    observer(({ mainStore }) => {
        const handleClick = () => mainStore.setMainStore("modal", { type: "uploadSortsFile", title: "Загрузка файла для сортировки" });

        return (
            <ButtonUI className="upload-sort-btn" onClick={handleClick} severity="secondary">
                <span>CSV</span>
                <i className={`pi pi-upload`} />
            </ButtonUI>
        );
    }),
);

export default UploadSortBtn;
